<template>
  <div role="list" class="padlet-cards-list" data-turbolinks="false">
    <padlet-card v-for="wall in sortedWalls"
                 :key="wall.id"
                 :wall="wall"
                 role="listitem"
                 :actions="actions" />
  </div>
</template>

<script>
import PadletCard from './padlet_card'
const dateSort = function (a, b) {
  if (a.updated_at > b.updated_at) { return -1 }
  if (a.updated_at == b.updated_at) { return 0 }
  return 1
}
const nameSort = function (a, b) {
  return a.title.localeCompare(b.title)
}
export default {
  components: { PadletCard },
  props: {
    walls: {},
    sortBy: {
      default: 'date'
    },
    actions: {
      default: false
    }
  },
  computed: {
    sortedWalls: function () {
      if (this.sortBy == 'date') {
        return this.walls.slice().sort(dateSort)
      }

      return this.walls.slice().sort(nameSort)
    }
  }
}
</script>

<style lang="scss">
@import "./../../assets/stylesheets/3/modules/all";

.padlet-cards-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin: 0 16px;
  background-image: url("../images/padlet_cards_backdrop@3x.png");
  background-size: 248px 146px;
}

.padlet-cards-sorter {
  display: flex;
  justify-content: flex-end;
  padding: 12px 0px;

  button {
    background: none;
    box-shadow: none;
    border: none;

    @include hover {
      color: var(--body-text-color);
    }
  }
}

@include respondToPortraitTablet {
  .padlet-cards-list {
    margin: 0 12px;
  }
}
</style>
